import React, { useState, useEffect } from "react";
import FormField from "../../../components/ui/FormField";
import { Button } from "../../../components/Button";

const MbpTwoForm = () => {

    const [footerInfo, setFooterInfo] = useState(() => {
        const saved = localStorage.getItem("mbp2_footer_info");
        return saved ? JSON.parse(saved) : { place: "", date: "", signature: "" };
    });

    const handleFooterChange = (field, value) => {
        const updated = { ...footerInfo, [field]: value };
        setFooterInfo(updated);
        localStorage.setItem("mbp2_footer_info", JSON.stringify(updated));
    };

    const [entries, setEntries] = useState(() => {
        const saved = localStorage.getItem("mbp2_register_data");
        return saved ? JSON.parse(saved) : [{ id: Date.now() }];
    });

    useEffect(() => {
        localStorage.setItem("mbp2_register_data", JSON.stringify(entries));
    }, [entries]);

    const updateField = (id, field, value) => {
        setEntries(prev =>
            prev.map(entry =>
                entry.id === id ? { ...entry, [field]: value } : entry
            )
        );
    };

    const addEntry = () => setEntries([...entries, { id: Date.now() }]);

    const deleteEntry = (id) => {
        if (entries.length > 1) {
            setEntries(entries.filter((e) => e.id !== id));
        }
    };
const saveData = () => {
    const payload = {
        registerName: "MBP-2",
        footer: footerInfo,
        entries: entries
    };

    console.log("MBP-2 PAYLOAD:",payload);
    console.log(JSON.stringify(payload, null, 2));
};

    return (
        <div >
            <div className="bg-white px-6 mb-4 border-b-4 shadow-sm rounded-t-lg text-center">
                <h1 className="text-2xl text-gray-900 uppercase tracking-tight">Form MBP - 2</h1>
                <h2 className="text-lg font-semibold">Register of loans, guarantee, security and acquisition made by the company</h2>
                <p className="text-[10px] italic text-slate-500 mt-2">
                    [Pursuant to section 186(9) & rule 12(1)]
                </p>
            </div>

            <div className="space-y-12">
                {entries.map((entry, index) => (
                    <div key={entry.id} className="bg-white border border-slate-200 rounded-lg shadow">

                        <div className="bg-primary text-white px-6 py-3 flex justify-between items-center">
                            <span className="font-semibold text-xs uppercase">
                                Entry No: {index + 1}
                            </span>
                            {entries.length > 1 && (
                                <button
                                    onClick={() => deleteEntry(entry.id)}
                                    className="text-[10px] bg-red-600 px-3 py-1 rounded hover:bg-red-700 uppercase"
                                >
                                    Remove
                                </button>
                            )}
                        </div>

                        <div className="p-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

                            <FormField label="(1) Nature of transaction" value={entry.nature} onChange={(v) => updateField(entry.id, "nature", v)} />
                            <FormField type="date" label="(2) Date of transaction" value={entry.date} onChange={(v) => updateField(entry.id, "date", v)} />
                            <FormField type="description" label="(3) Name & Address of the entity" value={entry.entity} onChange={(v) => updateField(entry.id, "entity", v)} />

                            <FormField label="(4) Amount" value={entry.amount} onChange={(v) => updateField(entry.id, "amount", v)} />
                            <FormField label="(5) Time period" value={entry.timePeriod} onChange={(v) => updateField(entry.id, "timePeriod", v)} />
                            <FormField type="description" label="(6) Purpose" value={entry.purpose} onChange={(v) => updateField(entry.id, "purpose", v)} />

                            <FormField label="(7) % Exposure" value={entry.exposurePercent} onChange={(v) => updateField(entry.id, "exposurePercent", v)} />
                            <FormField type="date" label="(8) Board resolution date" value={entry.boardDate} onChange={(v) => updateField(entry.id, "boardDate", v)} />
                            <FormField type="date" label="(9) Special resolution date" value={entry.specialResolutionDate} onChange={(v) => updateField(entry.id, "specialResolutionDate", v)} />

                            <FormField label="(10) Rate of Interest" value={entry.interestRate} onChange={(v) => updateField(entry.id, "interestRate", v)} />
                            <FormField type="date" label="(11) Date of maturity" value={entry.maturityDate} onChange={(v) => updateField(entry.id, "maturityDate", v)} />

                            <FormField label="(12) Number & Kind of securities" value={entry.securitiesType} onChange={(v) => updateField(entry.id, "securitiesType", v)} />
                            <FormField label="(13) Nominal & Paid-up value" value={entry.nominalValue} onChange={(v) => updateField(entry.id, "nominalValue", v)} />
                            <FormField type="description" label="(14) Cost of acquisition" value={entry.costAcquisition} onChange={(v) => updateField(entry.id, "costAcquisition", v)} />

                            <FormField type="date" label="(15) Date of selling" value={entry.sellingDate} onChange={(v) => updateField(entry.id, "sellingDate", v)} />
                            <FormField label="(16) Selling price" value={entry.sellingPrice} onChange={(v) => updateField(entry.id, "sellingPrice", v)} />
                            <FormField type="description" label="(17) Signatures & Remarks" value={entry.remarks} onChange={(v) => updateField(entry.id, "remarks", v)} />

                        </div>
                    </div>
                ))}
            </div>

            <Button
            label='Add New Entry'
                onClick={addEntry}
                className="mt-2"
            />
             
            <div className="mt-2 bg-white p-6 rounded-lg shadow grid grid-cols-1 md:grid-cols-3 gap-6">
                <FormField label="Place" value={footerInfo.place} onChange={(v) => handleFooterChange("place", v)} />
                <FormField type="date" label="Date" value={footerInfo.date} onChange={(v) => handleFooterChange("date", v)} />
                <FormField label="Signature (MD/Director/Secretary)" value={footerInfo.signature} onChange={(v) => handleFooterChange("signature", v)} />
            </div>
<Button
    label="SAVE"
    onClick={saveData}
    className="mt-4 bg-green-600 text-white"
/>
        </div>
    );
};

export default MbpTwoForm;
